window.gae = function(category,action,label) {
	if (window && window.document) {
		window.gaeList = window.gaeList || [];
		if(typeof(label) == 'undefined'){
			var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
			var label = 'mobile';
			if(w>1024){
				label = 'desktop';
			}else if(w>=768){
				label = 'tablet';
			};
		};
		window.gaeList.push(category + ', ' + action + ', ' + label);
		if(typeof(ga) !== 'undefined'){
			ga(function() {
				var gaName = ga.getAll()[0].get('name');
				ga(gaName + '.send', 'event', {
					eventCategory: category,
					eventAction: action,
					eventLabel: label
				});
			});
		};
		if (typeof (window.gtag) === 'function' || typeof(ga) !== 'undefined') {
			// Also log the event in snowplow
			if((typeof(snowplow) != 'undefined')){
				snowplow('trackStructEvent', category, action, label);
			};
			// Also log the event in inpectlet
			window.__insp = window.__insp || [];
			__insp.push(['tagSession', {"category": category, "action": action, "label": label }]);
		};
		if(window.location.href.indexOf('localhost') > -1 || window.location.href.indexOf('w1.') > -1){
			console.log('GAE',category,action,label);
		};

		var isIE = /*@cc_on!@*/false || !!document.documentMode;
		var isEdge = !isIE && !!window.StyleMedia;
		var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

		if(!(isIE || isEdge || isSafari)){
			var event = new Event('track');
			window.dispatchEvent(event);
		};
	}

	if (window && window.document) {
		if(typeof(favicon) != 'undefined'){
			setTimeout(function(){
				window.addEventListener('track', function(){
					if(typeof(window.badgeNum) == 'undefined') {
						window.badgeNum = 0;
					};
					badgeNum++;
					favicon.badge(badgeNum);
				});
			},2000);
		};
	}
};
